import { atom } from 'recoil';

export const headersState = atom({
  key: 'headersState',
  default: {
    "Accept": 'application/json',
    "Accept-Language": "sl-SI",
    "Time-Adjustment": (new Date().getTimezoneOffset() / 60)*-1,
  },
});

export let tokenState = atom({
  key: 'tokenState',
  default: {
    token: null,
    parsedToken: null,
  }
});

export let wsIdState = atom({
  key: 'wsIdState',
  default: null
});

export let wsNewMessageState = atom({
  key: 'wsNewMessageState',
  default: null
});

export let wsSubscribeToState = atom({
  key: 'wsSubscribeToState',
  default: null
});

export let multiCheckLoading = atom({
  key: 'multiCheckLoading',
  default: false
});

export let materialLoading = atom({
  key: 'materialLoading',
  default: false
});

export let serviceDraft = atom({
  key: 'serviceDraft',
  default: {
    isDraft: false,
    serviceId: null,
    values: null,
  }
});

export let saveContractToLinkedSystem = atom({
  key: 'saveContractToLinkedSystem',
  default: null
});

export let calendarScrollWeeks = atom({
  key: 'calendarScrollWeeks',
  default: []
});

export let calendarScrollLoading = atom({
  key: 'calendarScrollLoading',
  default: false
});

export let calendarRefresh = atom({
  key: 'calendarRefresh',
  default: false
});

export let updateProjectSystems = atom({
  key: 'updateProjectSystems',
  default: []
});